export default [
  {
    name: 'getParam',
    method: 'GET',
    path: '/vue/system/param-get'
  },
  {
    name: 'getParamList',
    method: 'POST',
    path: '/vue/system/param-page'
  },
  {
    name: 'saveParam',
    method: 'POST',
    path: '/vue/system/param-save'
  },
  {
    name: 'deleteParam',
    method: 'POST',
    path: '/vue/system/param-delete'
  },
  // 字典类型
  {
    name: 'getParamType',
    method: 'GET',
    path: '/vue/system/paramtype-get'
  },
  {
    name: 'getParamTypeList',
    method: 'POST',
    path: '/vue/system/paramtype-page'
  },
  {
    name: 'saveParamType',
    method: 'POST',
    path: '/vue/system/paramtype-save'
  },
  {
    name: 'deleteParamType',
    method: 'POST',
    path: '/vue/system/paramtype-delete'
  },
  {
    name: 'getSelectListByType',
    method: 'GET',
    path: '/vue/system/param-get-select-list'
  }
];
